import MainPage from '../pages/MainPage/MainPage'
import PATH from './path'
import PlatformManagementPage from '../pages/PlatformManagementPage/PlatformManagementPage'
import { ReactNode } from 'react'
import PlatformCardPage from '../pages/PlatformCardPage/PlatformCardPage'
import ReservationPlatformPage from '../pages/ReservationPlatformPage/ReservationPlatformPage'
import EditPlatformCardPage from '../pages/EditPlatformCardPage/EditPlatformCardPage'
import AdministratorsManagementPage from '../pages/AdministratorsManagementPage/AdministratorsManagementPage'
import AdminCardPage from '../pages/AdminCardPage/AdminCardPage'
import CompanyManagementPage from '../pages/CompanyManagementPage/CompanyManagementPage'
import CompanyCardPage from '../pages/CompanyCardPage/CompanyCardPage'
import EditCompanyCardPage from '../pages/EditCompanyCardPage/EditCompanyCardPage'
import CompanyManagementStaffPage from '../pages/CompanyManagementStaffPage/CompanyManagementStaffPage'
import CompanyStaffCardPage from '../pages/CompanyStaffCardPage/CompanyStaffCardPage'
import EditStaffCardPage from '../pages/EditStaffCardPage/EditStaffCardPage'
import CompanyManagementPlatformsPage from '../pages/CompanyManagementPlatformsPage/CompanyManagementPlatformsPage'
import ClaimManagementPage from '../pages/ClaimManagementPage/ClaimManagementPage'
import ClaimCardPage from '../pages/ClaimCardPage/ClaimCardPage'
import EditClaimCardPage from '../pages/EditClaimCardPage/EditClaimCardPage'
import Error404 from './Error/Error404'
import ClaimManagementCurrentPlatformPage from '../pages/ClaimManagementCurrentPlatformPage/ClaimManagementCurrentPlatformPage'
import RequestForRegistrationPage from '../pages/RequestForRegistrationPage/RequestForRegistrationPage'
import RequestForRegistrationCardPage from '../pages/RequestForRegistrationCardPage/RequestForRegistrationCardPage'
import PasswordRecoveryCodePage from '../pages/PasswordRecoveryCodePage/PasswordRecoveryCodePage'
import PasswordRecoverResetPasswordPage from '../pages/PasswordRecoverResetPasswordPage/PasswordRecoverResetPasswordPage'
import ProfilePage from '../pages/ProfilePage/ProfilePage'
import CompanyPage from '../pages/CompanyPage/CompanyPage'
import EditCompanyPage from '../pages/EditCompanyPage/EditCompanyPage'
import CompanyManagementStaffPageAdmin from '../pages/CompanyManagementStaffPageAdmin/CompanyManagementStaffPageAdmin'
import CompanyStaffCardPageAdmin from '../pages/CompanyStaffCardPageAdmin/CompanyStaffCardPageAdmin'
import ClaimsPage from '../pages/ClaimsPage/ClaimsPage'
import EstablishmentPage from '../pages/EstablishmentsPage/EstablishmentsPage'
import MenuPage from '../pages/MenuPage/menuPage'
import EstablishmentCardPage from '../pages/EstablishmentCardPage/EstablishmentCardPage'
import EditEstablishmentCardPage from '../pages/EditEstablishmentCardPage/EditEstablishmentCardPage'
import CollectOrdersPage from '../pages/CollectOrdersPage/collectOrdersPage'
import StatsPage from '../pages/StatsPage/StatsPage'
import ClientControlPage from '../pages/ClientControlPage/ClientControlPage'
import ClientsPage from '../pages/ClientPage/ClientPage'
import StrPage from '../pages/StrPage/StrPage'

type RouteType = {
  path: string
  component: ReactNode
}

export const superAdminRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.menuPage, component: <MenuPage /> },
  { path: PATH.strPage, component: <StrPage /> },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: `${PATH.editPlatformCardPage}:platformId`, component: <EditPlatformCardPage /> },
  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  { path: PATH.administratorsManagementPage, component: <AdministratorsManagementPage /> },
  { path: `${PATH.adminCardPage}:adminId`, component: <AdminCardPage /> },
  { path: PATH.companyManagementPage, component: <CompanyManagementPage /> },
  { path: `${PATH.companyCardPage}:companyId`, component: <CompanyCardPage /> },
  { path: `${PATH.editCompanyCardPage}:companyId`, component: <EditCompanyCardPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  { path: `${PATH.editStaffCardPage}:companyId/:workerId`, component: <EditStaffCardPage /> },
  {
    path: `${PATH.companyManagementPlatformsPage}:companyId`,
    component: <CompanyManagementPlatformsPage />,
  },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimsPage}`, component: <ClaimsPage /> },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.requestForRegistration, component: <RequestForRegistrationPage /> },
  {
    path: `${PATH.requestForRegistrationCardPage}:requestId`,
    component: <RequestForRegistrationCardPage />,
  },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },
  { path: `${PATH.editCompanyPage}:companyId`, component: <EditCompanyPage /> },

  // { path: PATH.createEstablishmentPage, component: <CreateEstablishmentPage /> },
  {
    path: `${PATH.companyManagementStaffPageAdmin}:companyId`,
    component: <CompanyManagementStaffPageAdmin />,
  },
  {
    path: `${PATH.companyStaffCardPageAdmin}:companyId/:workerId`,
    component: <CompanyStaffCardPageAdmin />,
  },
  { path: PATH.error404, component: <Error404 /> },
]

export const adminRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.strPage, component: <StrPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: `${PATH.editPlatformCardPage}:platformId`, component: <EditPlatformCardPage /> },
  { path: PATH.companyManagementPage, component: <CompanyManagementPage /> },
  { path: `${PATH.companyCardPage}:companyId`, component: <CompanyCardPage /> },
  { path: `${PATH.editCompanyCardPage}:companyId`, component: <EditCompanyCardPage /> },
  { path: PATH.menuPage, component: <MenuPage /> },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  { path: `${PATH.editStaffCardPage}:companyId/:workerId`, component: <EditStaffCardPage /> },
  {
    path: `${PATH.companyManagementPlatformsPage}:companyId`,
    component: <CompanyManagementPlatformsPage />,
  },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.requestForRegistration, component: <RequestForRegistrationPage /> },
  {
    path: `${PATH.requestForRegistrationCardPage}:requestId`,
    component: <RequestForRegistrationCardPage />,
  },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },
  { path: `${PATH.editCompanyPage}:companyId`, component: <EditCompanyPage /> },

  // { path: PATH.createEstablishmentPage, component: <CreateEstablishmentPage /> },
  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  {
    path: `${PATH.companyManagementStaffPageAdmin}:companyId`,
    component: <CompanyManagementStaffPageAdmin />,
  },
  {
    path: `${PATH.companyStaffCardPageAdmin}:companyId/:workerId`,
    component: <CompanyStaffCardPageAdmin />,
  },
  { path: PATH.error404, component: <Error404 /> },
]

export const directorAgentRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: `${PATH.claimsPage}`, component: <ClaimsPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.strPage, component: <StrPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: PATH.menuPage, component: <MenuPage /> },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  { path: `${PATH.editStaffCardPage}:companyId/:workerId`, component: <EditStaffCardPage /> },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },

  // { path: PATH.createEstablishmentPage, component: <CreateEstablishmentPage /> },
  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  // { path: PATH.claimsPage, component: <ClaimsPage /> },
  { path: PATH.error404, component: <Error404 /> },
]

export const directorPlaceRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: `${PATH.claimsPage}`, component: <ClaimsPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.strPage, component: <StrPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: `${PATH.editPlatformCardPage}:platformId`, component: <EditPlatformCardPage /> },
  { path: PATH.menuPage, component: <MenuPage /> },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  { path: `${PATH.editStaffCardPage}:companyId/:workerId`, component: <EditStaffCardPage /> },
  {
    path: `${PATH.companyManagementPlatformsPage}:companyId`,
    component: <CompanyManagementPlatformsPage />,
  },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },
  { path: `${PATH.editCompanyPage}:companyId`, component: <EditCompanyPage /> },

  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  { path: PATH.error404, component: <Error404 /> },
]

export const agentRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: `${PATH.claimsPage}`, component: <ClaimsPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },
  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
  { path: PATH.strPage, component: <StrPage /> },
  { path: PATH.error404, component: <Error404 /> },
]

export const platformRoutes: RouteType[] = [
  { path: '/', component: <MainPage /> },
  { path: `${PATH.claimsPage}`, component: <ClaimsPage /> },
  { path: PATH.ClientsPage, component: <ClientsPage /> },
  { path: PATH.clientControlPage, component: <ClientControlPage /> },
  { path: PATH.statsPage, component: <StatsPage /> },
  { path: PATH.establishmentPage, component: <EstablishmentPage /> },
  { path: PATH.siteManagementPage, component: <PlatformManagementPage /> },
  { path: `${PATH.platformCardPage}:platformId`, component: <PlatformCardPage /> },
  { path: PATH.companyManagementPage, component: <CompanyManagementPage /> },
  { path: `${PATH.companyCardPage}:companyId`, component: <CompanyCardPage /> },
  {
    path: `${PATH.companyManagementStaffPage}:companyId`,
    component: <CompanyManagementStaffPage />,
  },
  { path: `${PATH.companyStaffCardPage}:companyId/:workerId`, component: <CompanyStaffCardPage /> },
  {
    path: `${PATH.companyManagementPlatformsPage}:companyId`,
    component: <CompanyManagementPlatformsPage />,
  },
  { path: PATH.reservationPlatformPage, component: <ReservationPlatformPage /> },
  { path: `${PATH.editPlatformCardPage}:platformId`, component: <EditPlatformCardPage /> },
  {
    path: `${PATH.companyManagementPlatformsPage}:companyId`,
    component: <CompanyManagementPlatformsPage />,
  },
  { path: PATH.claimManagementPage, component: <ClaimManagementPage /> },
  {
    path: `${PATH.claimManagementCurrentPlatformPage}:platformId`,
    component: <ClaimManagementCurrentPlatformPage />,
  },
  { path: `${PATH.claimCardPage}:claimId`, component: <ClaimCardPage /> },
  { path: `${PATH.editClaimCardPage}:claimId`, component: <EditClaimCardPage /> },
  { path: PATH.passwordRecoveryCodePage, component: <PasswordRecoveryCodePage /> },
  { path: PATH.passwordRecoveryResetPasswordPage, component: <PasswordRecoverResetPasswordPage /> },
  { path: PATH.profilePage, component: <ProfilePage /> },
  { path: `${PATH.companyPage}:companyId`, component: <CompanyPage /> },
  { path: `${PATH.editCompanyPage}:companyId`, component: <EditCompanyPage /> },
  { path: `${PATH.establishmentCardPage}:establishmentId`, component: <EstablishmentCardPage /> },
  {
    path: `${PATH.editEstablishmentCardPage}:establishmentId`,
    component: <EditEstablishmentCardPage />,
  },
  { path: PATH.error404, component: <Error404 /> },
  { path: PATH.collectOrdersPage, component: <CollectOrdersPage /> },
]
